<template>
	<sf-data-table rowSize="lg" :columns="historyColumns" :rows="rows" index height="100%"> </sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/SQLEditor/store/helpers';
export default {
	props: {
		historyRows: { type: Array, default: () => [] }
	},
	data() {
		return {
			historyColumns: [
				{
					label: 'LOG_TYPE',
					prop: 'logType',
					minWidth: '100px'
				},
				{
					label: 'USER_ID',
					prop: 'userId',
					minWidth: '150px'
				},
				{
					label: 'LOG_DESC',
					prop: 'logDesc',
					minWidth: '250px'
				},
				{
					label: 'CDATE',
					prop: 'cDate',
					minWidth: '250px'
				},
				{
					label: 'LOG_BEFORE',
					prop: 'logBefore',
					minWidth: '500px'
				},
				{
					label: 'LOG_AFTER',
					prop: 'logAfter',
					minWidth: '500px'
				}
			]
		};
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		stringConverter(str) {
			var map = {
				'&': '&amp;',
				'<': '&lt;',
				'>': '&gt;',
				'"': '&quot;',
				"'": '&#039;'
			};
			return str.replace(/[&<>"']/g, function (m) {
				return map[m];
			});
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,

		rows() {
			return this.historyRows.map(row => ({
				...row,
				logBefore: this.stringConverter(row.logBefore),
				logAfter: this.stringConverter(row.logAfter)
			}));
		}
	},
	created() {
		//console.log('@@this.historyRows : log', this.historyRows);
	}
};
</script>

<style langType="scss"></style>
